// CookingSuccess.jsx
import { Box, Typography, Button, useTheme } from "@mui/material";
import CelebrationIcon from "@mui/icons-material/Celebration";
import Confetti from "react-confetti";
import { useEffect } from "react";

export const CookingSuccess = ({
  recipe,
  elapsedTime,
  onReset,
  resetStatus,
  onNavigateBack,
}) => {
  const theme = useTheme();

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        recycle={false}
        numberOfPieces={400}
      />

      <CelebrationIcon
        sx={{
          fontSize: 120,
          color: "#4CAF50",
          mb: 4,
          filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
        }}
      />

      <Typography
        variant="h2"
        sx={{
          mb: 2,
          fontWeight: 800,
          color: "#2e7d32",
          textAlign: "center",
        }}
      >
        Bon Appétit!
      </Typography>

      <Typography variant="h5" sx={{ mb: 4 }}>
        {recipe.recipe_name} is ready in {formatTime(elapsedTime)}
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="success"
          onClick={onNavigateBack}
          sx={{
            px: 6,
            py: 2,
            fontSize: "1.1rem",
            borderRadius: 4,
            boxShadow: 4,
          }}
        >
          Back to Recipes
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          onClick={onReset}
          disabled={resetStatus.loading}
          sx={{
            px: 6,
            py: 2,
            fontSize: "1.1rem",
            borderRadius: 4,
            borderWidth: 2,
          }}
        >
          {resetStatus.loading ? "Resetting..." : "Clean Kitchen"}
        </Button>
      </Box>

      <Typography
        variant="body1"
        sx={{
          mt: 6,
          color: theme.palette.text.secondary,
          textAlign: "center",
          maxWidth: 600,
          px: 2,
        }}
      >
        Remember to turn off appliances and clean your workspace. Share your
        culinary success with #SmartKitchen!
      </Typography>
    </Box>
  );
};
